import { getClientCustomFetch } from '../lib/getClientCustomFetch'

const getHomePage = async (data = {}) => {
  const customFetch = await getClientCustomFetch()
  const { storeId } = data
  const url = storeId ? `/layout/home?storeId=${storeId}` : '/layout/home'
  const response = await customFetch.get(url, {
    headers: {
      'Accept-Encoding': 'gzip',
      excludeAuth: true,
    },
  })
  return response?.data?.page
}

const getPage = async (data = {}) => {
  const customFetch = await getClientCustomFetch()
  const { page = '' } = data

  const response = await customFetch.get(`/layout/page?url=${page}`, {
    headers: {
      excludeAuth: true,
    },
  })
  return response?.data?.page
}

export { getHomePage, getPage }
